export default __webpack_public_path__ + "static/media/eMerge.41db8550.svg";